// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__3x9Jx","card":"Cards_card__2szqB","infected":"Cards_infected__2LZ59","recovered":"Cards_recovered__2zzMT","deaths":"Cards_deaths__3Dzli"};